import React, { Component } from 'react';
import { WithStyles, createStyles, Grid,  } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import contentRequestServices from '../../content-request/services/contentRequestServices';
import cx from 'classnames';
import env from '../../../config/config'
import _ from 'lodash';


const styles = (theme: Theme) => createStyles({
    previewButton: {
        fontSize: '1rem',
        fontWeight: 700,
    },
    PreviewTestCard:{
        border: '1px solid #D8D0D0',
        borderRadius: 4,
        width: '100%',
        margin: '10px 0 12px 0',
    },
    textRight:{
        textAlign: 'right',
    },
    textCenter:{
        textAlign: 'center',
    },
    btnPrimary: {
        color: '#1D7DEA',
        border: '1px solid #1D7DEA',
        padding: '10px 15px',
        backgroundColor: 'transparent',
        maxWidth: '100%',
        width: '100%',
        borderRadius: '3px',
        cursor: 'pointer'
    }
});

//@ts-ignore
interface PreviewTestProps extends WithStyles<typeof styles> {
    classes: any,
    content: any,
    testId: string
}

interface PreviewTestState {}

class PreviewTestComponent extends Component<PreviewTestProps, PreviewTestState>{	

    constructor(props: PreviewTestProps) {
        super(props);
    }

    getGoalName = (courseId: any[]) => {
		if (!!courseId.length) {
			return Array.from(new Set(courseId.map((course: any) => course.courseType.name))).join(', ');
		}
		return '-'
	}
    
     generateAuth = async () => {
      const res = await contentRequestServices.generatePreviewTestToken(this.props.testId);
      if (res && res.authToken) {
        const testData = {
            testId: this.props.testId,
            courseId: res.courseId,
            goal: this.getGoalName(_.get(this.props.content, "content.courseId", [])),
            testPreview: true
          };
        const queryParams = `authToken=${res.authToken}&testId=${testData.testId}&courseId=${testData.courseId}&goal=${testData.goal}&testPreview=true`;
        window.open(`${env.glorifireURL}?${queryParams}`, '_blank');
      }
    }

	render() {
        const { classes } = this.props;
		return (
            <>
             <Grid container direction="row" justify="center" alignItems="center">   
                <Grid className={classes.PreviewTestCard}>
                     <button className={cx(classes.btnPrimary, classes.previewButton)} onClick={this.generateAuth}>
                            Preview in Web 
                     </button>                   
                </Grid>
                        
             </Grid> 
            </>
        );
	}

}

// @ts-ignore
export default withStyles(styles)(PreviewTestComponent);

